// External
import { useState, useContext, useEffect, Fragment } from "react";
import { useSearchParams } from "react-router-dom";
import { MdDownload } from "react-icons/md";

// Internal
import { requestPartnerAPI } from "../../api/server";
import { UtilityContext } from "../../context/util-context";
import { AuthContext } from "../../context/auth-context";
import { uploadBase64String } from "../../util/uploadBase64String";
import VA from "../../assets/files/vehicle-agreement.pdf";
import SignaturePad from "../UI/SignaturePad";
import VehicleAgreement from "./VehicleAgreement";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";
import Heading from "../UI/Heading";

export default function SignVehicleAgreement() {
  const { user } = useContext(AuthContext);
  const { navigate } = useContext(UtilityContext);

  // Get ID from URL
  const [searchParams] = useSearchParams();
  const vin = searchParams.get("vin");

  // Initialize States
  const [loading, setLoading] = useState(true);
  const [vehicle, setVehicle] = useState();

  // ========================================== FETCH VEHICLE
  const fetchVehicleHandler = async () => {
    try {
      setLoading(true);
      const data = await requestPartnerAPI("fetch-vehicle", { vin: vin });
      setVehicle(data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  // ========================================== SIGN AGREEMENT
  const submitHandler = async (signature) => {
    try {
      setLoading(true);
      const signatureURL = await uploadBase64String(
        `partners/${user.uid}/signature`,
        signature
      );
      const url = await requestPartnerAPI("generate-vehicle-agreement", {
        vehicleId: vin,
        signature: signatureURL,
      });
      navigate(`/vehicles/info?vin=${vin}`);
      setLoading(false);
    } catch (err) {
      console.error(err.message);
      setLoading(false);
    }
  };

  // Fetch Vehicle on load
  useEffect(() => {
    fetchVehicleHandler();
  }, []);

  return (
    <div className="grid gap-4 bg">
      <Heading
        isBackArrow={true}
        title="Sign Vehicle Agreement"
        description="Please read the FAP Vehicle Agreement document carefully and scroll to the bottom to sign. Once signed, you will be able to download the signed document."
      >
        <a
          href={VA}
          download="power-of-attorney-template.pdf"
          target="blank"
          rel="noopener noreferrer"
          className="flex items-center p-2 space-x-2 btn-secondary"
        >
          <p className="hidden text-sm text-stone-200 md:block">
            Download Template
          </p>
          <MdDownload className="text-xl text-stone-200" />
        </a>
      </Heading>

      {loading ? (
        <LoadingSpinnerWrapper />
      ) : (
        <Fragment>
          <p className="font-semibold text-white md:text-lg">
            {vehicle?.year} {vehicle?.make} {vehicle?.model} - {vehicle?.vin}
          </p>

          <div className="h-full px-2 py-4 overflow-scroll border border-yellow-600 rounded-md">
            <div className="grid gap-6">
              <VehicleAgreement vehicle={vehicle} />
              <hr className="hr" />
              <SignaturePad setSignature={submitHandler} />
            </div>
          </div>
        </Fragment>
      )}
    </div>
  );
}
